// @flow
import React from 'react'
import { Link } from 'react-router'
import queryString from 'query-string'
import { LinkContainer } from 'react-router-bootstrap'
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap'
import { connect } from 'react-redux'
import Gravatar from 'react-gravatar'
import { loginUrl } from '../routes'
import styles from './NavBar.less'
import logo from '../images/logo-white.svg'
import * as actions from '../actions'
import { isLoggedIn, getAuth } from '../selectors'

// hack to fix https://github.com/react-bootstrap/react-bootstrap/issues/2365
const ExternalNavLink = ({
  href,
  children,
}: {
  href: string,
  children: any,
}) => (
  <li>
    <a href={href}>
      {children}
    </a>
  </li>
)

const InternalLink = ({
  children,
  Container = MenuItem,
  ...props
}: {
  children: any,
  Container?: any,
  props?: any,
}) => (
  <LinkContainer {...props}>
    <Container>
      {children}
    </Container>
  </LinkContainer>
)

const InternalNavLink = (props: ?any) =>
  InternalLink({
    Container: NavItem,
    ...props,
  })

const NavBar = ({
  isLoggedIn,
  email,
  name,
  logout,
  returnUrl,
}: {
  isLoggedIn: boolean,
  email?: string,
  name?: string,
  logout: Function,
  returnUrl: string,
}) => (
  <div>
    <Navbar inverse>
      <Navbar.Header>
        <Navbar.Brand>
          <Link to="/">
            <img className={styles.logo} src={logo} alt="submittable logo" />
            <span> Admin</span>
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        {isLoggedIn
          ? <Nav>
              <InternalNavLink to="/opportunities">
                Opportunities
              </InternalNavLink>
            </Nav>
          : null}
        <Nav pullRight>
          {isLoggedIn
            ? <NavDropdown
                title={<Gravatar email={email} size={20} />}
                id="logged-in-dropdown"
              >
                <MenuItem header>Signed in as {name}</MenuItem>
                <MenuItem divider />
                <InternalLink to="/login" onClick={logout}>
                  Sign out
                </InternalLink>
              </NavDropdown>
            : <ExternalNavLink
                href={`${loginUrl}?${queryString.stringify({ returnUrl })}`}
              >
                Sign in
              </ExternalNavLink>}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  </div>
)

const mapStateToProps = state => ({
  isLoggedIn: isLoggedIn(state),
  ...getAuth(state),
})

export default connect(mapStateToProps, actions)(NavBar)



// WEBPACK FOOTER //
// ./src/components/NavBar.js